import { Injectable } from "@angular/core";
import { Folio } from "../dto/orwi-folio";
import { Coupon } from "../dto/orwi-store";
import { OrwiService } from "../orwi.service";
import { UserService } from "../user/user.service";

@Injectable({
  providedIn: "root",
})
export class CouponService {
  constructor(
    private orwi: OrwiService,
    private us: UserService  ) {}

  loadCoupon(id) {
    return new Promise((resolve, reject) => {
      this.orwi
        .serviceRequestPromise(
          "/api/coupon/loadCoupon",
          { id: id },
          this.us.token
        )
        .then(
          (o: any) => {
            resolve(o);
          },
          () => {
            reject(undefined);
          }
        );
    });
  }

  getUserCoupons() {
    return new Promise((resolve, reject) => {
      this.orwi
        .serviceRequestPromise("/api/coupon/getUserCoupons", {}, this.us.token)
        .then(
          (o: any) => {
            if (o.response) {
              this.us.user.coupons = o.response;
              resolve(this.us.user.coupons);
            }
          },
          () => {
            reject(undefined);
          }
        );
    });
  }

  useCoupon(coupon: Coupon, folio: Folio): Promise<Folio> {
    let request = { id: coupon.id, folioId: folio.id, userId: this.us.user.id };
    return new Promise((resolve, reject) => {
      this.orwi
        .serviceRequestPromise(
          "/api/coupon/useCouponForPOS",
          request,
          this.us.token
        )
        .then(
          (o: any) => {
            if (o.response) {
              resolve(o.response);
            }
          },
          () => {
            reject(undefined);
          }
        );
    });
  }

  async couponImage(id) {
    return new Promise((resolve, reject) => {
      this.orwi
        .serviceRequestPromise("/api/image/coupon", { id: id }, this.us.token)
        .then(
          (o: any) => {
            if (o.response) {
              console.log(o.response);
              resolve(o.response);
            }
          },
          () => {
            reject(undefined);
          }
        );
    });
  }
}
